module.exports = __webpack_public_path__ + "img/kh22.78a8959c.png";